var _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#close_svg__clip0_10360_5331)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M28 0C12.56 0 0 12.56 0 28s12.56 28 28 28 28-12.56 28-28S43.44 0 28 0zm8.65 33.35A2.33 2.33 0 0135 37.333a2.327 2.327 0 01-1.65-.683L28 31.3l-5.35 5.35a2.327 2.327 0 01-1.65.683 2.33 2.33 0 01-1.65-3.983L24.7 28l-5.35-5.35a2.33 2.33 0 010-3.3 2.33 2.33 0 013.3 0L28 24.7l5.35-5.35a2.33 2.33 0 013.3 0 2.33 2.33 0 010 3.3L31.3 28l5.35 5.35z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "close_svg__clip0_10360_5331"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}
export default SvgClose;